<template>
    <ais-hits>
        <template v-slot="{ items }">
            <ul v-if="items.length">
                <li v-for="item in items" :key="item.objectID">
                    <a
                        :href="item.url"
                        class="py-6 md:py-10 block text-blue-500 border-blue-100 small last:border-b"
                    >
                        <h3 class="text-xl font-bold leading-snug">{{ item.title }}</h3>
                        <p class="mt-3 small">{{ item.description }}</p>
                    </a>
                </li>
            </ul>
            <div v-else>
                <h4 class="mt-10 mb-3 text-xl font-bold text-blue-500 md:mb-4">
                    {{ noResults.heading }}
                </h4>
                <div class="mb-8 text-blue-500 small wysiwyg" v-html="noResults.text"></div>
                <a class="mb-16 md:mb-4 btn" :href="noResults.buttonLink">{{
                    noResults.buttonText
                }}</a>
            </div>
        </template>
    </ais-hits>
</template>

<script>
import { ref, getCurrentInstance } from '@vue/composition-api';

export default {
    setup() {
        const instance = getCurrentInstance();
        const noResults = ref();

        if (instance?.proxy?.$root?.noResults) {
            noResults.value = JSON.parse(instance.proxy.$root.noResults);
        }

        return {
            noResults
        };
    }
};
</script>
